(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["o2o-footer"]) return;
  try {
    
  let cleanUpFooterFlow = () => {};
  function connectFooterFlow() {
    cleanUpFooterFlow();
    const outro = document.querySelector('#pink-dusk-home .pd-collection-outro');
    const letters = document.querySelector('#pink-dusk-home #pd-letters');
    const footer = document.getElementById('site-footer');
    if (!letters || !footer) return;
    const blocks = [outro, letters, footer].filter(Boolean);
    let frame = 0;
    function update() {
      const boxes = blocks.map(block => block.getBoundingClientRect());
      const first = boxes[0];
      const last = boxes[boxes.length - 1];
      const backdropWidth = Math.max(first.width, (last.bottom - first.top) * 3200 / 1179);
      const backdropSize = `${backdropWidth}px auto`;
      blocks.forEach((block, index) => {
        block.style.setProperty('--o2o-closing-size', backdropSize);
        block.style.setProperty('--o2o-closing-offset', `${first.top - boxes[index].top}px`);
      });
    }
    function schedule() {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(update);
    }
    const observer = new ResizeObserver(schedule);
    blocks.forEach(block => observer.observe(block));
    window.addEventListener('resize', schedule, { passive: true });
    update();
    cleanUpFooterFlow = () => {
      observer.disconnect();
      cancelAnimationFrame(frame);
      window.removeEventListener('resize', schedule);
      blocks.forEach(block => {
        block.style.removeProperty('--o2o-closing-offset');
        block.style.removeProperty('--o2o-closing-size');
      });
    };
  }
  connectFooterFlow();
  document.addEventListener('shopify:section:load', connectFooterFlow);
  document.addEventListener('shopify:section:unload', () => requestAnimationFrame(connectFooterFlow));

  } catch(e) { console.error(e); }
})();
})();
